import { render, staticRenderFns } from "./ChatMap.vue?vue&type=template&id=5e84e5a1&scoped=true&"
import script from "./ChatMap.vue?vue&type=script&lang=js&"
export * from "./ChatMap.vue?vue&type=script&lang=js&"
import style0 from "./ChatMap.vue?vue&type=style&index=0&id=5e84e5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84e5a1",
  null
  
)

export default component.exports